<app-widget-core [isClear]="isClear">

  <div class="widget-line-chart">

    @if (title) {

      <div class="title">{{ title }}</div>

    }

    <div class="chart-wrap">

      @if (data) {

        <apx-chart
          [series]="chartOptions.series!"
          [chart]="chartOptions.chart!"
          [dataLabels]="chartOptions.dataLabels!"
          [stroke]="chartOptions.stroke!"
          [legend]="chartOptions.legend!"
          [xaxis]="chartOptions.xaxis!"
          [yaxis]="chartOptions.yaxis!"
        ></apx-chart>

      } @else {

        <div class="no-data-chart">
          <ion-skeleton-text [animated]="true"></ion-skeleton-text>
        </div>

      }

    </div>

    <ng-content select="[extra-content]"></ng-content>

  </div>

</app-widget-core>
